<template>
  <!-- <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body"> -->

  <!-- Nueva modificación -->
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <!--Elaborar Proforma de Pago para OEC-->
        <app-breadcrumb
            page-title="Tesorería"
            directory="Elaborar Proforma"
            :icon="'trello'"
            v-if="code == '309'"
        />
        <!--Elaborar proforma pago inmediato-->
        <app-breadcrumb
            page-title="Tesorería"
            directory="Elaborar Proforma Pago Inmediato"
            :icon="'trello'"
            v-if="code == '213'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>
    <div
        class="row"
        v-if="inputs.evaluationList && inputs.evaluationList.length > 0"
    >
      <div class="col-12">
        <app-note
            class="pt-2 clearfix"
            :title="$t('Procesos en bloque')"
            content-type="html"
            note-type="note-warning"
            :notes="[
            $t(
              'Se adjuntará la misma proforma y documentos para las siguientes evaluaciones o testificaciones'
            ),
          ]"
        />
      </div>
      <br/>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
          <tr>
            <th scope="col">Expediente</th>
            <th scope="col">Tipo</th>
            <th scope="col">Código</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, key) in inputs.evaluationList" :key="key">
            <td class="align-middle">
              {{ value.accreditation_applications.record }}
            </td>
            <td class="align-middle">
              <br/>
              <p v-if="value.type == 'E'">Evaluación</p>
              <p v-if="value.type == 'T'">Testificación</p>
            </td>
            <td class="align-middle">{{ value.code }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <app-overlay-loader v-if="preloader"/>
        <form
            class="mb-0"
            ref="form"
            :class="{ 'loading-opacity': preloader }"
            enctype="multipart/form-data"
            :data-url="`/treasury/elaborateProforma/attachProforma/${inputs.id}`"
        >
          <!-- <div
            class="row"
            v-if="
              inputs.observations_evaluation_team &&
              inputs.observations_evaluation_team.length > 0
            "
          >
            <div class="col-12">
              <div class="form-group">
                <legend>
                  <label class="text-primary">Observaciones</label>
                </legend>
                <table class="table table-sm table-striped text-center">
                  <thead>
                    <tr>
                      <th scope="col">Observacion</th>
                      <th scope="col">Fecha</th>
                      <th scope="col">Usuario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(
                        value, index
                      ) in inputs.observations_evaluation_team"
                      :key="index"
                    >
                      <td>{{ value.observation }}</td>
                      <td>{{ dateToString(value.created_at) }}</td>
                      <td>
                        <strong v-if="value.user">{{
                          `${value.user.first_name} ${value.user.last_name} `
                        }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-6" v-if="evaluation_team_file">
              <div class="form-group">
                <label><strong>Propuesta del Equipo Evaluador</strong></label>
                <div>
                  <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab('evaluation_team_file')"
                  >
                    <app-icon name="file"/>
                    {{ $t("view") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12" v-if="proforms && proforms.length > 0">
              <div class="form-group">
                <legend>
                  <label class="text-primary">Historico de proformas</label>
                </legend>
                <table class="table table-sm table-striped">
                  <thead>
                  <tr>
                    <th scope="col">Observación</th>
                    <th scope="col" style="width: 15%; text-align: center">
                      Fecha
                    </th>
                    <th scope="col" style="width: 10%; text-align: center">
                      Ver
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, index) in proforms" :key="index">
                    <td>{{ value.observations }}</td>
                    <td style="text-align: center">
                      {{ dateToString(value.proform.created_at) }}
                    </td>
                    <td>
                      <a
                          class="btn btn-success"
                          :href="`${value.proform.full_url}`"
                          target="_blank"
                      >
                        <app-icon name="file"/>
                        Ver</a
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-if="haveAgreement">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label><strong>Convenio.</strong></label>
                    <div>
                      <button
                          type="submit"
                          class="btn btn-success"
                          @click.prevent="openFileAgreement('agreement_file')"
                      >
                        <app-icon name="file"/>
                        {{ $t("view") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <app-icon name="x" v-if="!icon"/>
              <app-note
                  class="mb-primary"
                  :show-title="false"
                  :notes="[$t(msg)]"
                  v-model="msg"
              />
            </div>
          </div>

          <div class="alert alert-warning" role="alert">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-danger" role="alert">
                  Esta opción debe ser usada solamente si se desea pasar a la etapa de designación sin agregar ninguna proforma
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>¿Pasar a la siguiente etapa sin agregar proforma?</label>
                  <app-input
                      type="radio-buttons"
                      v-model="desig_team"
                      :list="designateTeam"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div class="row" v-if="!desig_team">
            <div class="col-12">
              <div class="form-group">
                <label>¿Existe alguna observación a la propuesta de equipo evaluador?</label>
                <app-input
                    type="radio-buttons"
                    v-model="cancel_prof"
                    :list="cancelProforma"
                />
              </div>
            </div>
          </div>
          <div class="row" v-if="cancel_prof && !desig_team">
            <div class="col-6">
              <div class="form-group">
                <label><strong>Observación</strong></label>
                <app-input
                    type="textarea"
                    v-model="inputs.eval_test_observation"
                    placeholder="Ingrese observación"
                    :required="true"
                />
              </div>
            </div>
          </div>

          <div class="row" v-if="!cancel_prof && !desig_team">
            <div class="col-6" v-if="!inputs.cancel">
              <div class="form-group">
                <label><strong>Número de la Proforma</strong></label>
                <app-input
                    type="text"
                    v-model="inputs.proforma_number"
                    placeholder="Ingrese Número de la Proforma"
                    :required="true"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label><strong>Seleccione fecha máximo de pago</strong></label>
                <app-input
                    type="date"
                    v-model="inputs.datePayment"
                    placeholder="Fecha máximo de pago"
                    :required="true"
                />
              </div>
            </div>
            <div class="col-12" v-if="!preloader">
              <button type="submit" class="btn btn-primary float-right" @click.prevent="submitProformNumber">
                {{ inputs.proform_generated ? 'Actualizar proforma': 'Crear proforma'}}
              </button>
            </div>
          </div>
          <div class="row" v-if="!cancel_prof && !desig_team">
            <div class="col-6" v-if="!inputs.cancel && inputs.proform_generated">
              <div class="form-group">
                <label><strong>Adjuntar Proforma</strong></label>
                <app-input
                    type="file"
                    :label="
                    inputs.file ? inputs.file.name : $t('upload_your_file')
                  "
                    v-model="inputs.file"
                    :required="true"
                    v-on:change="fileChoosen"
                    v-if="!inputs.proforma"
                />
                <small class="text-center text-danger" v-if="!inputs.proforma">
                  <b>Tamaño máximo del archivo 8 MB</b>
                </small>
                <div>
                  <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab('proforma')"
                      v-if="inputs.proforma"
                  >
                    <app-icon name="file"/>
                    {{ $t("view") }}
                  </button>

                  <button
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="
                      () => {
                        inputs.proforma = null;
                      }
                    "
                      v-if="inputs.proforma"
                  >
                    <app-icon name="trash-2"/>
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>

            <div
                class="col-6 form-group row align-items-center" v-if="!inputs.cancel && inputs.proform_generated"
            >
              <label class="col-sm-8 mb-0"
              >Requiere Anexos de Honorarios? (En caso del personal
                externo)</label
              >
              <app-input
                  class="col-sm-4"
                  type="radio-buttons"
                  v-model="inputs.is_additonal_documentation"
                  :list="fee"
              />
            </div>

          </div>


          <br/>

          <proform-detail
              v-if="inputs.proform_generated && !cancel_prof && !desig_team"
              :proformGeneratedId="proformGeneratedId"
              :total="proformGeneratedTotal"
          />

          <div
              class="form-group row align-items-center"
              v-if="proforms.length > 0"
          >
            <label class="col-sm-4 mb-0">¿Anular Proforma?</label>
            <app-input
                class="col-sm-8"
                type="radio-buttons"
                v-model="inputs.cancel"
                :list="fee"
            />
          </div>
          <div class="row" v-if="inputs.cancel">
            <div class="col-12">
              <div class="form-group">
                <label>Razón de Anulación</label>
                <app-input
                    type="textarea"
                    :required="true"
                    v-model="inputs.observations"
                />
              </div>
            </div>
            <div class="col-12">
              <label>Adjunto</label>
              <app-input
                  id="proform_cancel_file"
                  type="file"
                  :label="
                  inputs.cancel_file
                    ? inputs.cancel_file.name
                    : $t('upload_your_file')
                "
                  v-model="inputs.cancel_file"
                  :required="true"
                  v-if="!inputs.proforma_cancel_file"
              />
              <a
                  v-if="inputs.proforma_cancel_file"
                  href="proforma_cancel_file.path"
                  class="btn btn-success btn-md mt-3"
                  target="_blank"
              >
                <app-icon name="file"></app-icon>
                Ver
              </a>
            </div>
          </div>

          <br/>

          <div
              class="form-group row align-items-center"
              v-if="haveAgreement && !cancel_prof && !desig_team"
          >
            <label class="col-sm-4 mb-0"
            >La Proforma tiene valor 0?</label
            >
            <app-input
                class="col-sm-8"
                type="radio-buttons"
                v-model="inputs.zero_proforma"
                :list="zeroProformaList"
            />
          </div>

          <div class="row" v-if="!desig_team && (external && external.length > 0) && inputs.is_additonal_documentation">
            <div class="col-12">
              <label><strong>Personal Externo</strong></label>
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col" class="align-middle">NOMBRE</th>
                    <th scope="col" class="align-middle">CORREO</th>
                    <th scope="col" class="align-middle">INSTITUCIÓN</th>
                    <th
                      scope="col"
                      class="align-middle text-center"
                      style="width: 20%"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ext, key) in external" :key="key">
                    <td>{{ ext.evaluator.first_name }} {{ ext.evaluator.last_name }}</td>
                    <td>{{ ext.evaluator.email }}</td>
                    <td>{{ ext.evaluator.institution }}</td>
                    <td class="align-middle text-center">
                      <app-input
                        :id="`file_${key}`"
                        type="file"
                        :label="ext.file ? ext.file.name : $t('upload_your_file')"
                        v-model="ext.file"
                        v-if="!ext.evaluation_team_external"
                        @change="onChange($event, ext)"
                      />
                      <div class="mt-2">
                        <button
                          type="submit"
                          class="btn btn-success"
                          @click.prevent="
                            openTabExt(ext, 'evaluation_team_external')
                          "
                          v-if="ext.evaluation_team_external"
                        >
                          <app-icon name="file" />
                          {{ $t("view") }}
                        </button>

                        <button
                          type="submit"
                          class="btn btn-danger"
                          @click.prevent="deleteFile(key)"
                          v-if="ext.evaluation_team_external"
                        >
                          <app-icon name="trash-2" />
                          {{ $t("delete") }}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <div class="row" v-if="inputs.is_additonal_documentation">
            <div class="col-6">
              <label>Correo electrónico del personal externo</label>
              <table class="table table-sm table-striped">
                <thead>
                <tr>
                  <th scope="col-md-8">Correo</th>
                  <th scope="col-md-2" class="text-center">
                    <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="addElement()"
                    >
                      <app-icon name="plus"/>
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(value, index) in inputs.external_emails"
                    :key="index"
                >
                  <td>
                    <app-input
                        type="email"
                        v-model="value.email"
                        placeholder="Ingrese Email"
                        :required="true"
                    />
                  </td>
                  <td class="text-center">
                    <button
                        type="submit"
                        class="btn btn-danger"
                        @click.prevent="deleteElement(index)"
                    >
                      <app-icon name="trash-2"/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12">
              <div class="form-group">
                <br/>
                <label
                >Adjuntar anexos de honorarios del personal externo</label
                >
              </div>
            </div>
          </div> -->
        </form>

        <!-- <attached-proforma-files
            :class="{ 'loading-opacity': preloader }"
            v-if="inputs.is_additonal_documentation"
            :inputs="inputs"
        /> -->
        <br/>
        <div v-if="!desig_team">
          <button v-if="inputs.proform_generated || cancel_prof" type="submit" class="btn btn-primary" @click.prevent="submit">
          Guardar
        </button>
        </div>

        <div v-if="desig_team">
          <button type="submit" class="btn btn-danger" @click.prevent="submit">
          Pasar al siguiente estado
        </button>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin.js";
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import AppLibrary from "../../../../../../../../resources/js/app/helpers/AppLibrary";
import * as actions from "../../../apiUrl";
import axios from "axios";

export default {
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    evaluationId: String,
  },
  data() {
    return {
      preloader: true,
      fileUrl: String,
      haveAgreement: false,
      msg: String,
      icon: false,
      urlPathagrementFile: String,
      code: String,
      inputs: {
        datePayment: null,
        proform_number: null
      },
      zeroProformaList: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      fee: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      cancel_prof: 0,
      desig_team: 0,
      cancelProforma: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      designateTeam: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      modalId: "modal-add-edit",
      proforms: [],
      is_new: true,
      evaluation_team_file: null,
      external: {},
    };
  },

  created() {
    this.dataInfo();
    this.dataExternal();
  },
  methods: {
    returnPage() {
      window.location.href = `/treasury/elaborateProforma`;
    },
    submit() {
      this.inputs.cancel_prof = this.cancel_prof;
      this.inputs.desig_team = this.desig_team;
      const tmp = {...this.inputs};
      if (tmp.external_emails.length) {
        const emails = tmp.external_emails.map((item) => item.email);
        tmp.external_emails = emails.join("|");
      }
      let countext = this.external.length;
      let countitem = 0;
      let id_eval = [];
      let eval_external = [];
      this.external.forEach((item) => {
        id_eval.push(item.id);
        eval_external.push(item.evaluator.email);
        if (item.evaluation_team_external) {
          countitem++;
        }
      });

      if (!this.desig_team && countext != countitem && this.inputs.is_additonal_documentation) {
        this.$toastr.e("Subir los anexos del personal externo");
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        formData.append(key, value);
      }
      formData.append(
        "id_eval[]", id_eval
      );
      formData.append(
        "eval_external[]", eval_external
      );
      this.selectedUrl = null;
      this.save(formData);
    },

    onChangeAnnexes(event){
      this.$store.commit('updateHasAnnexes', event);
    },

    submitProformNumber() {
      this.preloader = true;
      if (this.inputs.datePayment == null || this.inputs.proforma_number == null || this.inputs.proforma_number === ""){
        this.$toastr.e(
            "Indique el número de proforma y la fecha de pago para continuar"
        );
        this.preloader = false;
        return;
      }

      const dateSelected = this.getDateFormatForBackend(this.inputs.datePayment);

      if (this.inputs.proform_generated){
        //UPDATE
        const url =  `${actions.TREASURY_PROFORMA}/attachProforma/updateProform/${this.inputs.proform_generated.id}`;
        axios.patch(url, {proform: this.inputs.proforma_number, datePayment: dateSelected}).then((response)=>{
          this.inputs.proform_generated = response.data.proform;
          this.preloader = false;
          this.$toastr.s(this.$t("updated_success"));
        });
      }else{
        //CREATE
        const url = `${actions.TREASURY_PROFORMA}/attachProforma/${this.evaluationId}`;
        axios.patch(url, {proform: this.inputs.proforma_number, datePayment: dateSelected}).then((response) => {
          this.inputs.proform_generated = response.data.proform;
          this.preloader = false;
          this.$toastr.s(this.$t("updated_success"));
        })
      }

    },


    fileChoosen(event) {
      if (event.target.files[0].size > 8388608) {
        this.inputs.file = null;
        this.$toastr.e(
            "El tamaño maximo permitido del archivo de la proforma es de 8MB"
        );
      }
    },
    dataInfo() {
      this.selectedUrl = `${actions.TREASURY_PROFORMA}/attachProforma/${this.evaluationId}`;
      axios.get(this.selectedUrl).then((response) => {
        this.preloader = false;
        const tmp = response.data;
        tmp.external_emails = tmp.external_emails
            ? tmp.external_emails.split("|").map((item) => {
              return {email: item};
            })
            : [];
        tmp.cancel = 0;
        if (tmp.file_evaluation) {
          if (tmp.file_evaluation.type === "evaluation_team_file") {
            this.fileUrl = tmp.file_evaluation.full_url;
          }
        }
        this.inputs = tmp;
        if (this.inputs.proform_generated) {
          const datePayment = new Date(this.inputs.proform_generated.payment_date.toString().concat('T00:00:00'));
          this.inputs.datePayment = datePayment;
          this.$store.commit('updateProformTotal', this.inputs.proform_generated.total);
        }else{
          this.inputs.datePayment = new Date();
        }

        this.is_new = tmp.proforma_number == null;
        this.proforms = tmp.proforms;
        this.evaluation_team_file = tmp.evaluation_team_file;
        // Verificar si existen convenios activos de la organización.
        if (tmp.agreement) {
          this.msg = tmp.agreement.msg;
          this.haveAgreement = true;
          this.icon = tmp.agreement.icon;
          this.urlPathagrementFile = tmp.agreement.agrementFile;
        }
        // Obtener el codigo del status para mostrara directory
        axios.get(`${actions.TREASURY_PROFORMA}/attachProforma/codeStatus/${tmp.status}`).then((res) => {
          this.code = res.data.code;
        });

      });
    },

    dataExternal() {
      this.axiosGet(`${actions.TREASURY_PROFORMA}/externalStaff/${this.evaluationId}`).then((response) => {
        this.external = response.data;
      });
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      if (this.selectedUrl == null) {
        window.location.href = "/treasury/elaborateProforma";
      } else {
        this.selectedUrl = null;
      }
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    // afterSuccessFromGetEditData({ data: data }) {
    //   this.preloader = false;
    //   this.inputs = { ...data, external_emails: [{ email: null }], emails: [] };
    //   if (this.inputs.file_evaluation) {
    //     if (this.inputs.file_evaluation.type === "evaluation_team_file") {
    //       this.fileUrl = this.inputs.file_evaluation.full_url;
    //     }
    //   }
    // },
    openTab(fileName) {
      const w = window.open(this.inputs[fileName].path, "_blank");
      w.focus();
    },
    openFileAgreement(fileName) {
      const w = window.open(this.urlPathagrementFile, "_blank");
      w.focus();
    },
    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },
    addElement() {
      this.inputs.external_emails.push({
        email: null,
      });
    },
    deleteElement(index) {
      const tmp = this.inputs.external_emails.filter((item, i) => index != i);
      this.$set(this.inputs, "external_emails", tmp);
    },

    onChange($event, value) {
      const url = `${actions.TREASURY_PROFORMA}/evaluationTeamExternal/store`;
      let formData = new FormData();
      formData.append("file", $event.target.files[0]);
      for (const [key, value] of Object.entries(value)) {
        formData.append(key, value);
      }

      axios.post(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          this.$toastr.s(this.$t("updated_success"));
          this.dataExternal();
        })
        .catch(({ error }) => {});
    },

    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    deleteFile(pos) {
      this.external[pos].evaluation_team_external = null;
    },
  },
  computed: {
    proformGeneratedId() {
      return this.inputs.proform_generated.id.toString();
    },
    proformGeneratedTotal() {
      return this.inputs.proform_generated.total;
    }
  }
};
</script>
